// 각 컬럼의 고정 너비 (하드코딩)
const COLUMN_WIDTHS = {
  checkbox: "40px",
  dragHandle: "40px",
  no: "60px",
  empNum: "80px",
  name: "136px",
  role: "60px",
  age: "70px",
  grade: "104px",
  experience: "80px",
  isHeadNurse: "80px",
  weeklyOff: "80px",
  fixedShift: "150px",
  nightFixed: "90px",
  weekendOff: "90px",
  preceptor: "100px",
  mutualExclusion: "120px",
  wantedMaxRequests: "100px",
  enableAide: "100px",
  enableNursePairPreference: "100px",
  joiningDate: "120px",
  resignationDate: "120px",
  tenure: "100px",
  memo: "150px",
  edit: "80px",
};

export const headerList = [
  { label: "", width: COLUMN_WIDTHS.dragHandle },
  { label: "checkbox", width: COLUMN_WIDTHS.checkbox },
  { label: "No.", width: COLUMN_WIDTHS.no },
  { label: "사번", width: COLUMN_WIDTHS.empNum },
  { label: "이름", width: COLUMN_WIDTHS.name },
  { label: "직종", width: COLUMN_WIDTHS.role },
  { label: "직책", width: COLUMN_WIDTHS.role },
  { label: "Grade", width: COLUMN_WIDTHS.grade },
  { label: "경력", width: COLUMN_WIDTHS.experience },
  { label: "프리셉터", width: COLUMN_WIDTHS.preceptor },
  { label: "상호배제 인원", width: COLUMN_WIDTHS.mutualExclusion },
  { label: "근무형태", width: COLUMN_WIDTHS.fixedShift },
  { label: "나이트 개수", width: COLUMN_WIDTHS.nightFixed },
  { label: "주말 휴무", width: COLUMN_WIDTHS.weekendOff },
  // { label: "원티드 요청 제한", width: COLUMN_WIDTHS.wantedMaxRequests },
  // { label: "원티드 AI기능 사용", width: COLUMN_WIDTHS.enableAide },
  // { label: "시크릿기능 사용", width: COLUMN_WIDTHS.enableNursePairPreference },
  { label: "메모", width: COLUMN_WIDTHS.memo },
  { label: "관리", width: COLUMN_WIDTHS.edit },
];

export { COLUMN_WIDTHS };
